// source: pbtypes/gen/structure_scan/polygon.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2f_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2f_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2f_pb);
goog.exportSymbol('proto.structure_scan.Polygon', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.structure_scan.Polygon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.structure_scan.Polygon.repeatedFields_, null);
};
goog.inherits(proto.structure_scan.Polygon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.structure_scan.Polygon.displayName = 'proto.structure_scan.Polygon';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.structure_scan.Polygon.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.structure_scan.Polygon.prototype.toObject = function(opt_includeInstance) {
  return proto.structure_scan.Polygon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.structure_scan.Polygon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure_scan.Polygon.toObject = function(includeInstance, msg) {
  var f, obj = {
verticesList: jspb.Message.toObjectList(msg.getVerticesList(),
    pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.structure_scan.Polygon}
 */
proto.structure_scan.Polygon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.structure_scan.Polygon;
  return proto.structure_scan.Polygon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.structure_scan.Polygon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.structure_scan.Polygon}
 */
proto.structure_scan.Polygon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.deserializeBinaryFromReader);
      msg.addVertices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.structure_scan.Polygon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.structure_scan.Polygon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.structure_scan.Polygon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure_scan.Polygon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerticesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb.serializeBinaryToWriter
    );
  }
};


/**
 * repeated eigen_lcm.Vector2fPb vertices = 1;
 * @return {!Array<!proto.eigen_lcm.Vector2fPb>}
 */
proto.structure_scan.Polygon.prototype.getVerticesList = function() {
  return /** @type{!Array<!proto.eigen_lcm.Vector2fPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_eigen_lcm_Vector2f_pb.Vector2fPb, 1));
};


/**
 * @param {!Array<!proto.eigen_lcm.Vector2fPb>} value
 * @return {!proto.structure_scan.Polygon} returns this
*/
proto.structure_scan.Polygon.prototype.setVerticesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.eigen_lcm.Vector2fPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eigen_lcm.Vector2fPb}
 */
proto.structure_scan.Polygon.prototype.addVertices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.eigen_lcm.Vector2fPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.structure_scan.Polygon} returns this
 */
proto.structure_scan.Polygon.prototype.clearVerticesList = function() {
  return this.setVerticesList([]);
};


goog.object.extend(exports, proto.structure_scan);
